import { getBaseURL, getAPIKey, getOrigin } from '../../environment'
import { Client } from '../../models/Client'

const baseURL = getBaseURL()
const APIKey = getAPIKey()
const endpoint = '/clients/clients'
const origin = getOrigin()

export const getClientByLegacyCode = (
    legacyCode: string,
    millId: string
): Promise<Client | null> => {
    const genericSearch = JSON.stringify({
        fields: ['legacyCode'],
        searchValue: legacyCode,
    })

    const queryParams = new URLSearchParams({
        genericSearch,
        millId,
    })

    return fetch(`${baseURL}${endpoint}?${queryParams.toString()}`, {
        method: 'GET',
        headers: {
            'x-api-key': APIKey,
            'x-origin': origin,
        },
    })
        .then((response: Response) => response.json())
        .then((result) => {
            if (result.data && result.data.length > 0) {
                return result.data[0]
            }
            return null
        })
        .catch((err) => {
            console.error('Erro: ', JSON.stringify(err))
            throw err
        })
}
